import classes from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage.module.less";
import { Button } from "~/common/mui";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";
import { resolveUrl } from "~/utils/url/urlResolver";
import { useTranslation } from "react-i18next";

export function BannerHS() {
  const { t } = useTranslation();
  const isMinDesktop = useIsMinDesktopSize();
  const url = resolveUrl("/mount/induction-units-with-medium-frequency-technology");

  return (
    <>
      <img
        src={"https://cdn.schaeffler-ecommerce.com/cdn/bannerHeaterSelectionAssistant.jpg"}
        className={classes.bannerMsgImg}
      />
      {isMinDesktop ? (
        <>
          <div className={classes.bannerMsgText}>
            <div className={classes.bannerMsgTitle}>{t("heaterSelectionAssistant.banner.title")}</div>
            <div className={classes.bannerMsgDescription}>{t("heaterSelectionAssistant.banner.description")}</div>
          </div>
          <Button className={classes.bannerMsgButton} href={url}>
            {t("heaterSelectionAssistant.banner.button")}
          </Button>
        </>
      ) : (
        <div className={classes.bannerMsgText}>
          <div className={classes.bannerMsgTitle}>{t("heaterSelectionAssistant.banner.title")}</div>
          <div className={classes.bannerMsgDescPlusButton}>
            <div className={classes.bannerMsgDescription}>{t("heaterSelectionAssistant.banner.description")}</div>
            <Button className={classes.bannerMsgButton} href={url}>
              {t("heaterSelectionAssistant.banner.button")}
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
